<template>
  <div id="app">
    <div class="main-header bg-white border-bottom shadow-sm d-flex align-items-center px-3">
      <h4 class="text-secondary text-lead mr-3">DTT UI Components</h4>
      <a href="javascript:void(0)" @click="$router.push('/docs/')">Docs</a>
    </div>
    <RouterView />
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap');

#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #EDF2F9;
}

.main-header {
  height: 60px;
}
</style>
